import React from 'react';
import Grouped from '../../../components/Multiselect/Grouped';

export default function GroupField({ fields, handleDomainUrlChanges , targetField, targetValue }) {
  return (
    <>
      <Grouped
                handleChange={(val)=> handleDomainUrlChanges(val, targetField)}
                options={fields[targetField]||[]}
                value={{
                    value: `${fields[targetValue] || `choose ${targetValue.toLowerCase()}`}`,
                    label: `${fields[targetValue] || `choose ${targetValue.toLowerCase()}`}`,
                    color: "#5243AA"
                  }}
                  defaultOption={{
                    value: `${fields[targetValue]}`,
                    label: `${fields[targetValue]}`
                  }}
                />
    </>
  )
}
